export enum CtrPerformanceLevelEnum {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}
